import { useTranslation } from 'next-i18next';
import React from 'react';

import { NS } from '@/constants';
import { ItemModel, ReassuranceModel } from '@/models';
import { useAppDispatch, useAppSelector } from '@/redux';
import { toggleReassuranceModal } from '@/redux/slices/gui.slice';
import { getAttributeId } from '@/utils/productUtils';

import Icon from '@/components/common/iconedLinks/Icon';

import styles from './ReassuranceDesktop.module.scss';
import { URLS } from '@/constants/urls';

type ReassuranceDesktopProps = {
  reassurances: ReassuranceModel[];
  currentItem: ItemModel;
  alertPrimeur: string;
}

const ReassuranceDesktop = ({ reassurances, currentItem, alertPrimeur }: ReassuranceDesktopProps): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(NS.COMMON);

  const openReassurance = (reassurance) => {
    dispatch(toggleReassuranceModal({ opened: true, reassurance }));
  };

  return reassurances && (
    <ul className={styles.container}>
      {reassurances.map((reassurance) => {
        if (reassurance && reassurance.title && !reassurance.inStockToExcluded?.includes(getAttributeId(currentItem, 'in_stock')) &&
        !reassurance.inStockToExcluded?.includes(alertPrimeur)) {
          const { logoLink, logoAlt, shortDesc, title } = reassurance;
          return (
            <li key={logoLink} className={styles['list-item']} onClick={() => openReassurance(reassurance)}>
              <div className={styles.item}>
                <Icon
                  src={logoLink}
                  alt={logoAlt}
                  id={logoAlt}
                  width={24}
                  height={24}
                />
                <div className={styles.text}>
                  <span className={styles.title}>{title}</span>
                  <span>{shortDesc}</span>
                </div>
              </div>
              <Icon src={URLS.ANGLE_RIGHT_BLACK} alt={t('angleRightIcon', { ns: NS.ALTER })} />
            </li>
          );
        }
      })}
    </ul>
  );
};

export default ReassuranceDesktop;
